import { getShopTheLookVariant } from '../api/shopTheLook.api';

export const getLookVariantEvent = getShopTheLookVariant.matchFulfilled;
